<ng-container *transloco="let t;">
    <div class="modal-header">
        <h4 class="modal-title" id="myModalLabel1">{{ t('Add Document Field modal title - (Add Document Field modal) - Add Document Field') }}</h4>
        <button type="button" class="close" (click)="closeModal()" aria-label="Close">
            <span aria-hidden>&times;</span>
        </button>
    </div>
    <div class="modal-body" tabindex="0" ngbAutofocus>
        <label>{{ t('Add Document Field modal searchable field label - (Add Document Field modal) - Field name') }}</label>
        <div class="d-flex align-content-center customFieldAdd justify-content-between mb-75 w-100">
            <div class="input-group input-group-merge">
                <div class="input-group-prepend">
                    <span class="input-group-text"><i data-feather="search"></i></span>
                </div>
                <ng-autocomplete #fieldautocomplete [data]="metaData" [searchKeyword]="metadata_keyword"
                    [placeholder]="t('Add Document Field placeholder - (Add Document Field modal) - Add Document Field')" (selected)='selectMetaData($event)'
                    [itemTemplate]="itemTemplate" [isLoading]="loading"
                    (inputCleared)="clearCustomfieldValue()" [debounceTime]="500" [customFilter]="customMetaDataFilter"
                    class="form-control">
                </ng-autocomplete>

                <ng-template #itemTemplate let-item>
                    <div>
                        <a *ngIf="item?.id !== 0" [innerHTML]="item?.meta_data_name"></a>
                        <a *ngIf="item?.id === 0" [innerHTML]="item?.query"></a>
                    </div>
                </ng-template>
                <ng-template #notFoundTemplate let-notFound>
                    <div [innerHTML]="notFound"></div>
                </ng-template>
            </div>
        </div>
        <div class="docFieldInfoText d-flex">
            <small class="text-muted">{{ t('Add Document Field modal info description - (Add Document Field modal) - This Document Field will not show in the document this Document Field will only show in details for the sender to fill in If you wish to add a Document Field to the document use drag and drop from Blocks') }}</small>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="closeModal()" rippleEffect>
            {{ t('Cancel button title (cancel button) - Cancel') }}
        </button>
        <button type="button" [disabled]="!selectedField" class="btn btn-primary" rippleEffect (click)="insertField()">
            {{t('Add button text (add button) - add')}}
        </button>
    </div>
</ng-container>